import { useTranslation } from "react-i18next";

const DescriptionBox = ({ style, children, ...props }) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        ...style,
        position: "absolute",
        bottom: "4vw",
        left: "2vw",
        maxWidth: "20vw",
        display: "flex",
        padding: "2vw 2.5vw",
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 0.45)",
        color: "#fff",
        fontSize: "0.9vw",
        backdropFilter: "blur(10px)",
      }}
      dangerouslySetInnerHTML={{ __html: t(children) }}
    >
      {/* {t(children)} */}
    </div>
  );
};

export default DescriptionBox;
